<script setup lang="ts">import BrandLink from './Link.vue';defineProps<{to?:string;light?:boolean}>();</script>
<template><BrandLink v-if="to" :to="to" class="lux-button" :class="{light}"><slot /></BrandLink><button v-else class="lux-button" :class="{light}"><slot /></button></template>
